import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import OrgStructureItemsTable from '../../components/orgStructureItems/OrgStructureItemsTable';

const OrgStructureItems = () => (<WrapperSection><GlobalBreadcrumbs /><OrgStructureItemsTable /></WrapperSection>);
export default OrgStructureItems;
